import '@/scss/pages/blog-single.scss'

import { replaceQuizLink } from '@/js/common/replace-quiz-link'
import header from '../layout/header'
import fullForm from '../section/home/full-form'
import manageClassName from '../helpers/manage-class'
import singleCTA from '../section/blog/single-cta'
import { getTableOfContents } from '../common/table-of-contents'
import initExitPopup from '../section/exit-popup'
import anchor from '../common/anchor'
import initStrip from '../section/blog/strip'
import {
  setTrackExitPopupCloseEvent,
  setTrackStripCloseEvent
} from '../common/button-track'
import { bannerCta, bannerWide } from '../common/banners'
import { initClarity } from '@/js/helpers/clarity'
import config from '@/js/common/config.json'

document.addEventListener('DOMContentLoaded', function () {
  header()
  manageClassName('iframe', 'iframe-formatting', 'add')
  singleCTA()
  fullForm()
  getTableOfContents()
  initExitPopup()
  anchor()
  initStrip()
  setTrackExitPopupCloseEvent()
  setTrackStripCloseEvent()
  bannerWide()
  bannerCta()
  initClarity('#main', config.blog)
  replaceQuizLink()
})
